import axios from 'axios'

export default {
  name: 'edit-member-form',

  ui: {
    btSubmit: '[js-submit-edit-form]',
  },

  events: [
    {
      target: 'btSubmit',
      on: 'click',
      handle (e) {
        e.preventDefault()
        this.clickSubmit()
      },
    },
  ],

  componentDidMount () {},

  clickSubmit () {
    /* eslint-disable */
    this.el.querySelector(
      'textarea#activity'
    ).value = CKEDITOR.instances.activity.getData()
    this.el.querySelector(
      'textarea#activityEn'
    ).value = CKEDITOR.instances.activityEn.getData()
    /* eslint-enable */
    this.route = this.el.getAttribute('action')
    this.inputs = [
      ...this.el.querySelectorAll(
        'input:not([type=submit]):not([name=""]), textarea'
      ),
    ]
    const formData = new FormData()
    this.inputs.forEach((el, i) => {
      // test for input file value
      const type = el.getAttribute('type')
      const value = type && type === 'file' ? el.files[0] : el.value
      //
      formData.append(el.name, value)
    })
    this.ui.btSubmit.disabled = true
    axios
      .post(this.route, formData)
      .then(response => {
        // console.log(response.data)
        this.ui.btSubmit.disabled = false
        if (response.data.success) document.location.reload() // hardcore way of life baby
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },
}
